


























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import AuthService from '@/services/auth';
import LanguageService from '@/services/language';

@Component
export default class Navigation extends Vue {
    authService = new AuthService();

    languageService = new LanguageService();

    showNavigation: boolean = null;

    showLangSelection = false;

    showProfileSelection = false;

    languages = [
        {
            label: 'English',
            code: 'en',
        },
        {
            label: 'Nederlands',
            code: 'nl',
        },
        {
            label: 'Français',
            code: 'fr',
        },
    ];

    get navigationItems() {
        return [
            {
                label: this.$t('navigation.home'),
                path: '/',
            },
            {
                label: this.$t('navigation.about'),
                path: '/about',
            },
        ];
    }

    get currentLanguage(): string {
        return this.$i18n.locale;
    }

    mounted(): void {
        this.hide();
    }

    goToProfile() {
        this.hide();
        this.showProfileSelection = true;
    }

    hideProfileSelection() {
        this.hide();
        this.showProfileSelection = false;
    }

    show() {
        this.showNavigation = true;
    }

    setLanguage(language: any) {
        this.showLangSelection = false;
        this.languageService.language = language.code;
        this.hide();
    }

    logout() {
        this.authService.logout();
        this.$router.replace('/');
        this.$nextTick(() => window.location.reload());
    }

    @Watch('$route', { immediate: true, deep: true })
    hide() {
        this.showNavigation = false;
    }
}
